import React from 'react';
import { connect } from 'react-redux';
import {
  taxesPageRequest,
  changeDateTaxes,
  changeOutletTaxes,
  exportTaxes,
} from 'actions/reports/sales';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild';
import { rupiahWithNegativeWithoutBracket } from 'utils/formatter';
import _ from 'lodash';
import * as clevertapReportsTaxes from 'clevertap/reports/taxes';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import ActionBar from '../ActionBar';
import styles from './Taxes.css';
import BodyFrame from '../BodyFrame';

class Taxes extends React.Component {
  componentDidMount() {
    this.props.dispatch(taxesPageRequest());
  }

  render() {
    const { taxes, showLoadingSpinnerReport } = this.props.data.reports.taxes;
    const [footBody, childBody] = this._formatDataForList(
      taxes,
      taxes.total_tax_collected
    );
    const footBodyResponsive = this._formatFootBody(_.cloneDeep(footBody));
    const childBodyResponsive = this._formatChildBody(_.cloneDeep(childBody));

    return (
      <div id="reports-sales-taxes" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
        />
        <BodyFrame location={this.props.location}>
          <div className={`${styles.tableWrapper} visible-md visible-lg`}>
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {taxes.reports_taxes && taxes.reports_taxes.length > 0 && (
              <TableWithoutChild
                headerBody={[
                  'Name',
                  'Tax Rate',
                  'Taxable Amount',
                  'Tax Collected',
                ]}
                childBody={childBody}
                footBody={footBody}
                tableClass="tax-table"
                headerBodyClassName={[
                  'header-name',
                  'header-tax-rate',
                  'header-taxable-amount',
                  'header-tax-collected',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-tax-rate',
                  'body-taxable-amount',
                  'body-tax-collected',
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-tax-rate',
                  'foot-taxable-amount',
                  'foot-tax-collected',
                ]}
              />
            )}
            {taxes.reports_taxes &&
              !taxes.reports_taxes.length &&
              !showLoadingSpinnerReport && (
                <div className="no-data-display-container">
                  <NoDataDisplay title="No Data to Display" />
                </div>
              )}
          </div>
          <div
            className={`${styles.tableWrapperResponsive} visible-xs visible-sm`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {taxes.reports_taxes && taxes.reports_taxes.length > 0 && (
              <TableWithoutChild
                headerBody={['Name', 'Tax Rate', 'Tax Collected']}
                childBody={childBodyResponsive}
                footBody={footBodyResponsive}
                tableClass="tax-table-responsive"
                headerBodyClassName={[
                  'header-name',
                  'header-tax-rate',
                  'header-tax-collected',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-tax-rate',
                  'body-tax-collected',
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-tax-rate',
                  'foot-tax-collected',
                ]}
              />
            )}
            {taxes.reports_taxes &&
              !taxes.reports_taxes.length &&
              !showLoadingSpinnerReport && (
                <div className="no-data-display-container">
                  <NoDataDisplay title="No Data to Display" />
                </div>
              )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _formatDataForList = (taxes, totalTaxCollected) => {
    const childBody = [];
    const footBody = {
      name: 'Total',
      total_tax_rate: null,
      total_taxable_amount: null,
      totalTaxCollected: rupiahWithNegativeWithoutBracket(totalTaxCollected),
    };
    if (taxes.reports_taxes) {
      taxes.reports_taxes.map(function(tax) {
        childBody.push({
          name: tax.name,
          amount: tax.amount,
          taxable_amount: rupiahWithNegativeWithoutBracket(tax.taxable_amount),
          tax_collected: rupiahWithNegativeWithoutBracket(tax.tax_collected),
        });
      });
    }
    return [footBody, childBody];
  };

  _formatFootBody = footBody => {
    delete footBody.total_taxable_amount;
    return footBody;
  };

  _formatChildBody = childBody => {
    const result = [];
    childBody.map(function(val) {
      delete val.taxable_amount;
      result.push(val);
    });
    return result;
  };

  _onChangeOutlet = (outletIds = []) => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletTaxes({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { outlet: outletIds } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateTaxes(formattedStart, formattedEnd, outletIds)
    );
  };

  _onClickExport = () => {
    const {
      outlet,
      date: { startDate, endDate, startHour, endHour, allDay },
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    const filename = `Report Taxes - ${dateLabel}`;
    const query = {
      start: formattedStart,
      end: getFormattedEndDate(formattedEnd),
      outletIds: outlet,
      filename,
    };
    clevertapReportsTaxes.reportsTaxExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    this.props.dispatch(exportTaxes(query, filename, outlet[0]));
  };
}

const selector = formValueSelector('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: {
        taxes: state.reports.taxes,
      },
      outlet: state.outlet,
      calendar: state.calendar,
    },
  };
}

export default connect(select)(Taxes);
